import { Injectable, NgZone } from "@angular/core";
import {
  Clients,
  authenticationService,
} from "../Authentication/authentication.service";
import { AngularFireDatabase } from "@angular/fire/database";
import {
  LocalNotifications,
  ELocalNotificationTriggerUnit,
  ILocalNotification,
} from "@ionic-native/local-notifications/ngx";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { AlertController, Platform } from "@ionic/angular";
import { SharedService } from "../sheared/sharedService.service";
import { SqlitebaseService } from "../Sqlite/Sqlitebase.service";
import { isUndefined } from "util";
import { Router } from "@angular/router";
import { $ } from "protractor";
import { AssureurService } from "../Assureur/assureur.service";
import { FactoryService } from "../historique/factory.service";
import { FCM } from "cordova-plugin-fcm-with-dependecy-updated/ionic/ngx";
import { BehaviorSubject, Subscription } from "rxjs";
import { environment } from "src/environments/environment.prod";
declare var cordova: any;
@Injectable({
  providedIn: "root",
})
export class NotificationService {
  expanded: true;
  lstAss: any[];
  public $keyTemp: any[] = [];
  private i: number = 49;
  dataNotify;
  clickSub: any;
  public hasPermission: boolean;
  private asSub = new Subscription();
  private idfcmChat: number = 100; //[101;199] => 200
  private idfcmPub: number = 199; //[200;220] => 21
  private idfcmDoc: number = 220; //[221,230]=> 10
  update_tbl_chat:any[]=[]
  nbChat:  BehaviorSubject<any>= new BehaviorSubject<any>({added:false})
  
  constructor(
    private db: AngularFireDatabase,
    private alertController: AlertController,
    private localNotify: LocalNotifications,
    private fact: FactoryService,
    private route: Router,
    private zon: NgZone,
    private sqlitebase: SqlitebaseService,
    private assurance: AssureurService,
    private platform: Platform,
    private fcm: FCM,
    private httpClient: HttpClient,
    private sharedService: SharedService
  ) {
    this.platform.ready().then(() => {
      if (this.platform.is("cordova")) {
        cordova.plugins.notification.local.on("yes", (res) => {
          if (res.id >= 50 && res.id <= 100) {
            this.zon.run(() => {
              this.fact.setData(30, res.data.objetPolice);
              this.route.navigate(["prime/30"]);
            });
          } else {
            this.zon.run(() => this.route.navigate(["prime"]));
          }
        });
        this.localNotify.on("click").subscribe((res) => {
          if (res.id >= 50 && res.id <= 100) {
            this.zon.run(() => {
              this.fact.setData(30, res.data.objetPolice);
              this.route.navigate(["prime/30"]);
            });
          } else if (res.id >= 101 && res.id <= 199) {
            this.zon.run(() =>
              this.route.navigate(["/chat", res.data.assureur])
            );
          } else if (res.id >= 200 && res.id <= 220) {
            this.zon.run(() => this.route.navigate(["pub"]));
          } else if (res.id >= 221 && res.id <= 230) {
            this.zon.run(() => this.route.navigate(["historique"]));
          } else {
            this.zon.run(() => this.route.navigate(["alerts"]));
          }
          //this.unsub();
        });
      }
    });

    this.assurance.ListAssreurs.subscribe((res) => {
      this.lstAss = res;
    });
  }
  unsub() {
    this.clickSub.unsubscribe();
  }

  async histPolicesPartage(uid) {
    const tree = this.db.database.ref();
    const ref2 = tree.child("Quittances");

    await ref2
      .orderByChild("idkeyPar")
      .equalTo(uid)
      .on("child_added", (snapshot) => {
        const $key = snapshot.key; // clé hashée de quittance
        tree.child(`Quittances/${$key}`).once("value", (snap) => {
          let lstPaie = [];
          let item0 = [];
          let p = snap.val();
          if (p) {
            if (p.notifyPartage === undefined) {
              for (const key in p.listPaie) {
                if (Object.prototype.hasOwnProperty.call(p.listPaie, key)) {
                  const element = p.listPaie[key];
                  if (element.solde) {
                    lstPaie.push({
                      modePayement: element.modePayement,
                      montantPayement: element.montantPayement,
                      mtnLivraison: element.mtnLivraison,
                    });
                  }
                }
              }

              if (!p.solde) {
                var datejr = this.sharedService.getDate();
                var ex = this.sharedService.ConvertDMYorYMD(
                  p.dateExpi,
                  "y/m/d"
                );
                let objetAssur = this.lstAss.find(
                  (e) => e.CodeAssu == p.CodeAssur
                );

                item0.push({
                  id: 70,
                  $key: snap.key,
                  police: p.NumPolice,
                  NumPolice: p.NumPolice + " [ " + objetAssur.NomAssu + " ]",
                  // mtntLivraison: objetAssur.mtnLivreur,
                  numClient: p.numClient,
                  CodeAssur: p.CodeAssur,
                  duree: this.sharedService.diffDays(datejr, ex) * 1 + 1,
                  Immat: p.Immat != "" ? p.Immat : "",
                  montant_due: p.montant_due,
                  nbPaie: lstPaie.length,
                  montant_restant:
                    p.montant_due -
                    lstPaie.reduce(
                      (acc, curr) => Number(acc) + Number(curr.montantPayement),
                      0
                    ),
                  montantVerse: lstPaie.reduce(
                    (acc, curr) => Number(acc) + Number(curr.montantPayement),
                    0
                  ),
                  montant_paye: p.montant_paye, //this.sharedService.eparateurMil(snap.payload.exportVal().montant_paye),
                  dateEffet: p.dateEffet,
                  dateExpi: p.dateExpi,
                  icon: p.icon,
                  isChecked: false,
                  idproprio: p.idKey,
                  partage: p.idkeyPar,
                  namePar: p.namePar,
                  idKey: p.idKey,
                });
              }

              this.localNotify.schedule({
                id: 55,
                vibrate: true,
                led: { color: "#FF00FF", on: 500, off: 500 },
                title: "Transfert de simulation",
                text:
                  "Vous avez reçu une simulation de N° police " +
                  snap.val().NumPolice,
                lockscreen: true,
                wakeup: true,
                icon: this.lstAss.find(
                  (e) => e.CodeAssu == snap.val().CodeAssur
                ).icon,
                data: { objetPolice: item0[0] },
                foreground: true,
                // actions: [
                //   { id: 'yes', title: 'Renouveler', launch: true },
                //   { id: 'no', title: 'Marquer comme Lu' }
                // ]
              });

              this.updatePartage($key);
            }
          }
        });
      });

    //return await this.PrepareData(handelResult,"oui")
  }

  updatePartage($key: string) {
    this.db.object(`Quittances/${$key}`).update({
      notifyPartage: true,
    });
  }

  notifyPaiement(uid: string) {
    let appeler = true;
    var tbl = Array<ILocalNotification>();
    var tbl2 = [];
    const tree = this.db.database.ref();
    const ref2 = tree.child("Quittances/");
    ref2.orderByChild("idKey")
      .equalTo(uid)
      .on("child_added", (Datasnapshot) => {
        const $key = Datasnapshot.key; // clé hashée
        tree.child(`Quittances/${$key}`).once("value", (snapshot) => {
          let p = snapshot.val();
          let Mtvers = 0;
          let Nbvers = 0;
          if (p.etatdoc === "" && !p.notify) {
            for (const key in p.listPaie) {
              if (Object.prototype.hasOwnProperty.call(p.listPaie, key)) {
                const element = p.listPaie[key];
                if (element.solde) {
                  Mtvers += Number(element.montantPayement);
                  Nbvers++;
                }
              }
            }
            this.i++;
            let dataObjet = this.prepareNotification(p);
            p.msg = dataObjet.msg;
            p.montant_restant = p.montant_due;
            p.police = p.NumPolice;
            (p.nbPaie = Nbvers), (p.montantVerse = Mtvers); //p.
            p.$key = $key;
            this.schedulerAvisEcheance(
              {
                id: this.i,
                vibrate: true,
                led: { color: "#FF00FF", on: 500, off: 500 },
                title: "Statut contrat N° " + p.NumPolice,
                text: dataObjet.msg,
                lockscreen: true,
                wakeup: true,
                icon: dataObjet.icon,
                data: { objetPolice: p },
                foreground: true,
                actions: [
                  { id: "yes", title: "Renouveler", launch: true },
                  { id: "no", title: "Marquer comme Lu" },
                ],
                //attachments: [dataObjet.logo]
              },
              p
            );
          }
        });
      });
  }

  schedulerAvisEcheance(lstnotifications: ILocalNotification, e: any) {
    let sql = this.sharedService.getDateSepar();
    let timestemp = this.sharedService.getTimeStampFromToday();

    setTimeout(
      () => {
        this.localNotify.schedule(lstnotifications);

        this.db
          .object(`Quittances/${e.$key}`)
          .update({
            notify: true,
          })
          .then(() => {
            this.sqlitebase.addNotifications(
              "Contrat",
              e.msg,
              timestemp,
              sql.J,
              sql.M,
              sql.A,
              sql.h,
              sql.m,
              sql.s,
              "create"
            );
            this.sqlitebase.addDataNotifyAutomation(
              e.$key,
              e.NumPolice,
              e.dateEffet,
              e.dateExpi,
              this.sharedService.getDate(),
              "1",
              "0"
            );
            this.funCalcule();
          });
      },
      100,
      lstnotifications
    );
  }

  private prepareNotification(contrat) {
    var datejr = this.sharedService.getDate();
    var ex = this.sharedService.ConvertDMYorYMD(contrat.dateExpi, "y/m/d");
    var duree = this.sharedService.diffDays(datejr, ex) * 1 + 1;
    let dataObjet = {
      msg: "",
      icon: "",
    };

    if (contrat.type === "Auto") {
      if (duree == 0) {
        dataObjet.msg =
          "Cher(e) client(e), votre contrat d'assurance \n" +
          "automobile d'immatriculation " +
          contrat.Immat +
          "\n" +
          "dont le N° police est " +
          contrat.NumPolice +
          ",\n" +
          "expire aujourd'hui à 00h.\n" +
          "Cliquez sur << Renouveler >> afin de vous réassurer";
      } else if (duree > 0) {
        dataObjet.msg =
          "Cher(e) client(e), votre contrat d'assurance \n" +
          "automobile d'immatriculation " +
          contrat.Immat +
          "\n" +
          "dont le N° police est " +
          contrat.NumPolice +
          ",\n" +
          "expire  dans " +
          Math.abs(duree) +
          " jour(s).\n" +
          "Cliquez sur << Renouveler >> afin de vous réassurer";
      } else if (duree < 0) {
        dataObjet.msg =
          "Cher(e) client(e), votre contrat d'assurance \n" +
          "automobile d'immatriculation " +
          contrat.Immat +
          "\n" +
          "dont le N° police est " +
          contrat.NumPolice +
          ",\n" +
          "a expiré depuis " +
          Math.abs(duree) +
          " jour(s).\n" +
          "Cliquez sur << Renouveler >> afin de vous réassurer";
      }
    } else {
      if (duree == 0) {
        dataObjet.msg =
          "Cher(e) client(e), votre contrat d'assurance \n" +
          "de numéro de police " +
          contrat.NumPolice +
          "\n" +
          "expire aujourd'hui à 00h.\n" +
          "Veuillez selectionner les options de Nsia Bia Bia \n" +
          "Cliquez sur << Renouveler >> afin de vous réassurer";
      } else if (duree > 0) {
        dataObjet.msg =
          "Cher(e) client(e), votre contrat d'assurance \n" +
          " de numéro de police " +
          contrat.NumPolice +
          " expire\n" +
          "dans " +
          Math.abs(duree) +
          " jour(s).\n" +
          "Cliquez sur << Renouveler >> afin de vous réassurer";
      } else if (duree < 0) {
        dataObjet.msg =
          "Cher(e) client(e), votre contrat d'assurance \n" +
          "de numéro de police " +
          contrat.NumPolice +
          " a expiré\n" +
          "depuis " +
          Math.abs(duree) +
          " jour(s).\n" +
          "Cliquez sur << Renouveler >> afin de vous réassurer";
      }
    }
    dataObjet.icon = this.lstAss.find(
      (e) => e.CodeAssu == contrat.CodeAssur
    ).icon;

    return dataObjet;
  }
  // Pour gérer les dépots d'argent concernant les souscriptions par anticipation
  notifyPaymentWithOutReturn(profil: Clients) {
    var tbl = [];
    var i = 0;
    this.db
      .list(`Quittances`, (ref) =>
        ref.orderByChild("idKey").equalTo(profil.uid)
      )
      .snapshotChanges(["child_changed"])
      .subscribe((Datasnapshot) => {
        tbl = [];
        Datasnapshot.forEach((snapshot) => {
          // debugger
          let totalMnt = 0;
          for (const key in snapshot.payload.exportVal().listPaie) {
            if (
              Object.prototype.hasOwnProperty.call(
                snapshot.payload.exportVal().listPaie,
                key
              )
            ) {
              const element = snapshot.payload.exportVal().listPaie[key];
              if (element.solde && element.withOut) {
                totalMnt += element.montantPayement;
              }
            }
          }
          if (totalMnt !== 0) {
            i = 50;
            const item = snapshot.payload.toJSON();
            //this.schedulerAvisEcheance(item, profil, snapshot.payload.key)
          }
        });
      });
  }

  notifyDocument(profil: string) {
    var tbl = [];
    var i = 0;
    this.db
      .list(`Quittances`, (ref) => ref.orderByChild("idKey").equalTo(profil))
      .snapshotChanges(["child_changed"])
      .subscribe((Datasnapshot) => {
        tbl = [];
        Datasnapshot.forEach((snapshot) => {
          if (
            snapshot.payload.exportVal().etatdoc === "pret" &&
            !snapshot.payload.exportVal().notifydoc
          ) {
            const item = snapshot.payload.toJSON();
            //this.NotifiDocprete(item, snapshot.payload.key)
          }
        });
      });
  }

  //#region  Notification de rappel de contrat expiré (id=40)
  private MyNotifyAutoScheduling(contrat, duree) {
    var msg = "";
    if (duree == 0) {
      msg =
        "Cher(e) client(e), votre contrat d'assurance de numéro de police " +
        contrat.NumPolice +
        "\n" +
        "expire aujourd'hui à 00h.\n" +
        "Utiliser Nsia Bia Bia pour vous réassurer directement";
    } else if (duree > 0) {
      msg =
        "Cher(e) client(e), votre contrat d'assurance de numéro de police " +
        contrat.NumPolice +
        " expire\n" +
        "dans " +
        Math.abs(duree) +
        " jour(s).\n" +
        "Utiliser Nsia Bia Bia pour anticiper le renouvellement";
    } else if (duree < 0) {
      msg =
        "Cher(e) client(e), votre contrat d'assurance de numéro de police " +
        contrat.NumPolice +
        " a expiré\n" +
        "depuis " +
        Math.abs(duree) +
        " jour(s).\n" +
        "Utiliser Nsia Bia Bia pour rapidement vous réassurer";
    }

    this.localNotify.schedule({
      id: 40,
      led: { color: "#FF00FF", on: 500, off: 500 },
      title: "Statut contrat",
      text: msg,
      smallIcon: "res://calendar",
      groupSummary: true,
      vibrate: true,
      //trigger: { every: { minute: mm } },
      foreground: true,
    });
    if (duree >= 0) this.presentAlert("Statut contrat", "Expiration", msg);
    else
      this.presentAlertWithStop(
        "Statut contrat",
        "Expiration",
        msg,
        contrat.$key
      );
  }
  //#endregion

  //Notification appelée de l'extérieur

  //#region Notification pour paiement de la prime (id=20)
  NotifiPaiement(numId: number, police: string, icon: string, avance: Boolean) {
    let myNotifications = [];
    let msg = "";
    //console.log(contrats);
    if (avance) {
      msg =
        "Cher(e) client(e), vous venez de faire une avance \n" +
        "sur votre police d'assurance n° " +
        police +
        ".\n" +
        "Pensez à la solder rapidement afin que\n" +
        "votre contrat soit établi et livré au besoin.\n" +
        "Nous vous remercions pour la confiance que \n" +
        "vous nous témoignée.";
    } else {
      msg =
        "Cher(e) client(e), vous venez de payer la prime \n" +
        "de votre contrat d'assurance de numéro police " +
        police +
        ".\n" +
        "votre document est en cours de préparation.\n" +
        "Dans les heures qui suivent,vous serez livré.\n" +
        "Nous vous remercions pour la confiance que \n" +
        "vous nous témoignée.";
    }

    myNotifications.push({
      id: numId,
      vibrate: true,
      led: { color: "#FF00FF", on: 500, off: 500 },
      title: "Statut de paiement",
      text: msg,
      lockscreen: true,
      icon: icon,
      foreground: true,
      wakeup: true,
      //attachments: [logo]
    });
    // console.log(myNotifications);
    this.localNotify.schedule(myNotifications);

    this.sqlitebase.addNotifications(
      "Paiement",
      msg,
      this.sharedService.getTimeStampFromToday(),
      this.sharedService.getDateSepar().J,
      this.sharedService.getDateSepar().M,
      this.sharedService.getDateSepar().A,
      this.sharedService.getDateSepar().h,
      this.sharedService.getDateSepar().m,
      this.sharedService.getDateSepar().s,
      "cash"
    );
  }
  //#endregion

  //#region Notification pour document prêt (Id=221)
  private NotifiDocprete(data, dat) {
    this.localNotify.schedule({
      id: this.idfcmDoc++,
      led: { color: "#FF00FF", on: 500, off: 500 },
      title: data.title,
      text: data.body,
      foreground: true,
    });
    this.sqlDoc(dat, data);
  }
  private sqlDoc(dat, data) {
    if (dat.data.$key != "" && !isUndefined(dat.data.$key)) {
      this.db.object(`Quittances/${dat.data.$key}`).update({
        notifydoc: true,
      });
    }
    this.sqlitebase.addNotifications(
      "Document",
      data.body,
      this.sharedService.getTimeStampFromToday(),
      this.sharedService.getDateSepar().J,
      this.sharedService.getDateSepar().M,
      this.sharedService.getDateSepar().A,
      this.sharedService.getDateSepar().h,
      this.sharedService.getDateSepar().m,
      this.sharedService.getDateSepar().s,
      "document"
    );
  }
  //#endregion
  /**
   * this function allow you to scheduled in loop the execution of localNotification.
   * every day at 00h ,the program test if the sqlLite has the valid datas
   *
   */
  goAtMidnight() {
    const d = new Date();
    var night = new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate() + 1,
      0,
      0,
      0
    );
    let goTime = night.getTime() - d.getTime();
    let IdTimeout: NodeJS.Timer;
    this.sqlitebase.loadNotifyAutomatique().then((data) => {
      if (data.rows.length > 0) {
        IdTimeout = setTimeout(() => {
          this.goAtMidnight();
          this.funCalcule();
        }, goTime); //2 * 60 * 1000)
      } else {
        clearTimeout(IdTimeout);
      }
    });
  }
  //#Preparation des données pour la notification
  /**
   * This function prepare data for the scheduled notifications
   */
  private funCalcule() {
    // Effectuer la requete pour savoir s'il existe des polices à notifier
    //let timerID: NodeJS.Timer
    var datejr = this.sharedService.getDate();
    this.sqlitebase
      .loadNotifyAutomatique()
      .then((data) => {
        //this.loading.dismiss()

        if (data.rows.length > 0) {
          for (var i = 0; i < data.rows.length; i++) {
            let e = {
              Id: data.rows.item(i).IdNotify,
              IDquit: data.rows.item(i).IDquit,
              NumPolice: data.rows.item(i).NumPolice,
              DateEffet: data.rows.item(i).DateEffet,
              DateExpirat: data.rows.item(i).DateExpirat,
              DateInsert: data.rows.item(i).DateInsert,
              Etat: data.rows.item(i).Etat,
              Stop: data.rows.item(i).Stop,
            };
            var ex = this.sharedService.ConvertDMYorYMD(e.DateExpirat, "y/m/d");
            var duree = this.sharedService.diffDays(datejr, ex) * 1 + 1;
            let heure_prog = [];
            switch (true) {
              //3 fois par jour à [8h,12h,15h]
              case duree >= 1 && duree <= 7:
                heure_prog = [e, [8, 12, 15], duree];
                break;
              //2 fois par jour à [8h,15h]
              case duree > 7 && duree <= 15:
                heure_prog = [e, [8, 15], duree];
                break;
              //1 fois par semaine à [10h]
              case duree > 15 && duree <= 30:
                heure_prog = [e, [10], duree];
                break;
              case duree < 0:
                heure_prog = [e, [10, 20], duree];
                break;
            }
            // console.log("Lance heure_prog", heure_prog);
            // debugger
            if (heure_prog.length > 0) {
              this.funNotifyCalc(heure_prog);
            }
          }
        }
      })
      .catch((error) => {
        console.log("Erreur 2");

        console.error(error);
      })
      .finally
      //() => this.loading.dismiss()
      ();
  }
  //#endregion

  async presentAlert(header, sub, msg) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      subHeader: sub,
      mode: "ios",
      buttons: [
        {
          text: "Reporter",
          role: "cancel",
          cssClass: "primary",
          handler: () => {
            //this._objet = "Selectionner l'objet"
          },
        },
        {
          text: "Payer",
          handler: () => {
            this.route.navigate(["prime"]);
          },
        },
      ],
    });
    await alert.present();
  }
  async presentAlertWithStop(header, sub, msg, $key) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      subHeader: sub,
      mode: "ios",
      buttons: [
        {
          text: "Reporter",
          role: "cancel",
          cssClass: "primary",
          handler: () => {
            //this._objet = "Selectionner l'objet"
          },
        },
        {
          text: "ne plus afficher",
          //role: 'cancel',
          cssClass: "primary",
          handler: () => {
            //this._objet = "Selectionner l'objet"
            this.sqlitebase.updateNotifyAutomation($key, "1", "1");
          },
        },
        {
          text: "Payer",
          handler: () => {
            this.route.navigate(["prime"]);
          },
        },
      ],
    });
    await alert.present();
  }

  /**
   * this function allow you to launch the program of localNotification
   *
   */
  private funNotifyCalc(h_pro: any) {
    //const h_pro=[11,15,17]
    let i = 0;
    let that = this;
    let timerID = setTimeout(
      function myTimer(h_pro) {
        const d = new Date();
        const dx =
          ((d.getUTCHours() + 1) * 3600 +
            d.getUTCMinutes() * 60 +
            d.getUTCSeconds()) *
          1000;
        //const dxf = ((18) * 3600 + h_pro[1][i] * 60) * 1000; //testing
        const dxf = h_pro[1][i] * 3600 * 1000; // production
        let timeDiff = dxf - dx;
        // Evaluate the tx sign and including the h_pro array
        if (timeDiff < 0 && h_pro[1].length !== i + 1) {
          i++;
          myTimer(h_pro);
        } else if (timeDiff > 0) {
          timerID = setTimeout(
            (h_pro) => {
              that.MyNotifyAutoScheduling(h_pro[0], h_pro[2]);
              if (h_pro[1].length !== i + 1) {
                i++;
                myTimer(h_pro);
              } else {
                clearTimeout(timerID);
              }
            },
            timeDiff,
            h_pro
          );
        } else {
          clearTimeout(timerID);
        }
      },
      100,
      h_pro
    );
  }

  //Notification de Chat
  private NotifyChat(msg, data0: any) {
    this.localNotify.schedule({
      id: this.idfcmChat++,
      vibrate: true,
      led: { color: "#FF00FF", on: 500, off: 500 },
      title: data0.NomAssu,
      text: msg,
      //lockscreen: true,
      lockscreen: true,
      wakeup: true,
      foreground: true,
      //wakeup: true,
      icon: data0.icon,
      data: { assureur: data0.CodeAssu },
      //foreground: true
    });
  }
  //Notification de publicité
  private NotyfyPub(body, data0) {
    this.localNotify.schedule({
      id: this.idfcmPub++,
      vibrate: true,
      led: { color: "#FF00FF", on: 500, off: 500 },
      title: data0.NomAssu,
      lockscreen: true,
      wakeup: true,
      foreground: true,
      icon: data0.icon,
      attachments: [data0.imageUrl],
      //wakeup: true,

      //foreground: true
    });
  }
  async setupFCM(auth: authenticationService,uid) {
    if (
      this.platform.is("ios") ||
      this.platform.is("android") ||
      this.platform.is("iphone") ||
      this.platform.is("mobile") ||
      this.platform.is("ipad") ||
      this.platform.is("mobileweb")
    ) {
      try {
        debugger
        this.fcm.deleteInstanceId()
        this.fcm.getToken().then((token) => {
          auth.updateToken(token,uid);
        });
          // refresh the FCM token
          this.fcm.onTokenRefresh().subscribe((newToken) => {
            auth.updateToken(newToken, uid);
          });
        this.hasPermission = await this.fcm.requestPushPermission();
        this.fcm.onNotification().subscribe((data) => {
          let dat = JSON.parse(data.payload);
          if (data.wasTapped) {
            switch (dat.message) {
              case "chat":
                const res = this.lstAss.find((e) => e.CodeAssu == dat.ass);
                if (res) {
                  this.zon.run(() => this.route.navigate(["/chat", dat.ass]));
                  this.asSub.unsubscribe();
                }
                break;
              case "pub":
                this.zon.run(() => this.route.navigate(["pub"]));
                break;
              case "doc_pret":
                this.sqlDoc(dat, data);
                this.zon.run(() => this.route.navigate(["historique"]));
                break;
              default:
                break;
            }

            // console.log('Received in background');
          } else {
            // si je suis sur une autre console que la méssagerie,
            const res = this.lstAss.find((e) => e.CodeAssu == dat.ass);
            switch (dat.message) {
              case "chat":
                if (res) {
                  if (
                    (res.CodeAssu === "1000" && !this.fact.openView0Chat) ||
                    (res.CodeAssu === "1001" && !this.fact.openView1Chat) ||
                    (res.CodeAssu === "1002" && !this.fact.openView2Chat) ||
                    (res.CodeAssu === "1003" && !this.fact.openView3Chat)
                  ) {
                    this.NotifyChat(data.body, res);
                  }
                }
                break;
              case "pub":
                if (res) {
                  this.NotyfyPub(data.body, res);
                }

                break;
              case "doc_pret":
                //this.notifyDocument

                this.NotifiDocprete(data, dat);
                // this.zon.run(( () =>  this.route.navigate(['historique'])))
                break;
              default:
                break;
            }
            //console.log('Received in foreground');
          }
        });
      
      } catch (error) {}
    }
  }

  sendNotifyCloud(register, police, prop, image = "") {
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json",
      }),
    };
    let userNotify = [];
    userNotify.push(register);
    const data = this.checkpayload(police, prop);
    const objetData = {
      notificationPriority: "",
      actionType: "",
      userFcmToken: [...userNotify],
      notificationBadge: false,
      ...data,
    };
    
    this.httpClient.post(environment.API_URL_PROD_NOTIFY, objetData, httpOptions)
      .subscribe(
        (data) => {
          // if (dialog)  dialog.close(1);
          // this.sendOK.next(true);
          
          //{"multicast_id":2553725301030034152,"success":0,"failure":1,"canonical_ids":0,"results":[{"error":"NotRegistered"}]}
        },
        (error: HttpErrorResponse) => {
          console.log(error.name + " " + error.message);
        }
      );
  }

  private checkpayload(police, sender) {
    const variant: any = {
      notificationTitle: "Réception de simulation",
      notificationBody:"Cher(e) client(e), vous avez reçu une simulation de N° police " + police +" provenant de " + sender,
      payload: {},
    };
    //let msg =
   //variant.notificationBody = msg;
    //variant.foreground = true;

    return variant;
  }

   getmessage_added(uid) {
    this.nbChat.next({added:false})

    const anc_message = this.db.database.ref(`Messages/${uid}`);
    anc_message.on("child_added", (snapshot) => {
      const code_comp = snapshot.key; // clé hashée
      //console.log("Messages", code_comp);
      return anc_message.child(`/${code_comp}`).orderByChild('read').equalTo(false). 
      on("child_added", (snap) => {
        
        if (snap.val().useId !==uid) {
            this.nbChat.next({added:true})
            this.update_tbl_chat.push({code:code_comp,key:snap.key})
        }
      });
    });
  }

}
